import { isEmpty, find, cloneDeep } from 'lodash'

const defaultRoles = [
  { name: 'Legal Rep', value: 'legal' },
  { name: 'Super Admin', value: 'admin' },
  { name: 'Competition Owner', value: 'user' }
]

const superRoles = cloneDeep(defaultRoles)
superRoles.push({ name: 'Root', value: 'superadmin' })

const initialState = {
  currentUser: {},
  userList: [],
  roles: defaultRoles,
  superAdminRoles: superRoles,
  statuses: ['enabled', 'disabled', 'deleted'],
  countriesList: []
}
export default {
  namespaced: true,
  state: Object.assign({}, initialState),
  getters: {
    roles(state) {
      if (state.currentUser.role === 'superadmin') {
        return state.superAdminRoles
      } else {
        return state.roles
      }
    },
    isSignedIn(state) {
      return !isEmpty(state.currentUser)
    },
    isSuperAdmin(state) {
      return state.currentUser.role === 'superadmin'
    },
    isAdmin(state) {
      return state.currentUser.role === 'admin' || state.currentUser.role === 'superadmin'
    },
    transformedUsersToPrivileges(state) {
      return state.userList.map((user) => {
        let obj = {}
        obj.role = user.id === state.currentUser.id ? 'editor' : 'no-access'
        obj.user_id = user.id
        obj.name = user.name
        return obj
      })
    },
    userById: (state) => (userId) => {
      return find(state.userList, { id: userId })
    }
  },
  mutations: {
    resetStateData(state) {
      for (let prop in state) {
        state[prop] = initialState[prop]
      }
    },
    setUserData(state, data) {
      state.currentUser = data
    },
    setUsersList(state, data) {
      state.userList = data.data
    },
    setOneUserInUserList(state, data) {
      if (state.currentUser.id === data.id) {
        state.currentUser = data
      }
      state.userList.forEach((user, key) => {
        if (user.id === data.id) {
          state.userList.splice(key, 1)
          state.userList.push(data)
        }
      })
    },
    setCountries(state, data) {
      state.countriesList = data
    }
  },
  actions: {
    resetStateData({ commit }) {
      commit('resetStateData')
    },
    setUserData({ commit }, data) {
      commit('setUserData', data)
    },
    async getUsers({ commit, dispatch }, payload = {}) {
      if (payload.limit && payload.page) {
        payload.offset = payload.limit * (payload.page - 1)
      }
      try {
        const response = await dispatch(
          'app/makeCall',
          {
            route: 'user.getUsers',
            payload
          },
          { root: true }
        )
        commit('setUsersList', response.data)
        return response.data
      } catch (error) {
        throw error.response
      }
    },
    async getUser({ dispatch }, { id }) {
      try {
        const response = await dispatch(
          'app/makeCall',
          {
            route: 'user.getUser',
            payload: { id }
          },
          { root: true }
        )
        return response.data
      } catch (error) {
        throw error.response
      }
    },
    async updateUser({ dispatch, commit }, payload) {
      try {
        const response = await dispatch(
          'app/makeCall',
          {
            route: 'user.updateUser',
            payload
          },
          { root: true }
        )
        commit('setOneUserInUserList', response.data)
      } catch (error) {
        throw error.response
      }
    },
    async createUser({ dispatch }, payload) {
      try {
        await dispatch(
          'app/makeCall',
          {
            route: 'user.createUser',
            payload
          },
          { root: true }
        )
      } catch (error) {
        throw error.response
      }
    },
    async checkGdpr({ dispatch }, payload) {
      try {
        const response = await dispatch(
          'app/makeCall',
          {
            route: 'user.checkGdpr',
            payload
          },
          { root: true }
        )
        return response.data
      } catch (error) {
        throw error.response
      }
    },
    async getCountriesList({ dispatch, commit }) {
      try {
        const response = await dispatch(
          'app/makeCall',
          {
            route: 'user.getCountries'
          },
          { root: true }
        )
        commit('setCountries', response.data)
        return response.data
      } catch (error) {
        throw error.response
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js